import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiVisa, Core2Config } from "../../../shared";

@Injectable({ providedIn: "root" })
export class BotHandoverService {
    constructor(private http: HttpClient) { }

    agentHandover(data:any, apiVisa: ApiVisa, apiUrl){
        let url = apiUrl + Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "conversation/handover/agent-to-bot";
        return this.http.post(url, data, this.getHttpHeader(apiVisa));
    }

    public getHttpHeader(apiVisa: ApiVisa) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'tenant-code': apiVisa.tenantCode,
            'token': apiVisa.jwt_secret
          })
        };
        return httpOptions;
      }
    
}
